<template>
  <div class="CertificateReport">
    <div class="main-content" v-if="!isUserGroupAdmin">
      <certificate-grid-tab @clickedTab="selectedTab"></certificate-grid-tab>
      <report-filter-bar @selectedGroupObj="setGroupCourseObj" @selectedCohortObj="setCohortObj" v-bind:showExport="showExportButton" @isExportBtnClicked="exportCSV" @isViewBtnClicked="updateViewBtnClickedFlag" v-if="currentSelectedTab === 1 || currentSelectedTab === 2"></report-filter-bar>
      <report-group-filter-bar @selectedGroupObj="setGroupObj" :showExport="showExportButton" @isExportBtnClicked="exportCSV" @isViewBtnClicked="updateViewBtnClickedFlag" v-if="currentSelectedTab === 3 || currentSelectedTab === 4"></report-group-filter-bar>
      <hr width="94%" size="10px">
      <div class="row milestoneList margin-Top-2Perc">
        <div class="col-md-12 col-lg-12 width-97Point4 margin-left-1point5Perc">
          <sortable-list v-if="showCertificateList" v-bind:responseObj="getReportArr" v-bind:sortableColumnName="sortColumnNames" v-bind:columnNameToShow="columnNameToShow" v-bind:linkColumnName="linkColumnNames" v-bind:selectedsubOption="10"></sortable-list>
        </div>
      </div>
      <div class="row margin-Top-3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Copyright-Element class="footer"></Copyright-Element>
        </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
    </div>
    <loader></loader>
    <error-page v-if="isUserGroupAdmin"></error-page>   
  </div>
</template>
<script>
import ReportGroupFilterBar from '@/components/ReportGroupFilterBar'
import CertificateGridTab from '@/components/reports/certificate/CertificateGridTab'
import ReportFilterBar from '@/components/ReportFilterBar'
import list from '@/pages/SortableList'
import CopyrightElement from '@/components/CopyrightElement'
import AlertBox from '@/components/AlertOverlay'
import ErrorPage from '@/pages/Error'
import { constants } from '@/utils/constants'
import { reportService } from '@/server-util/report-service'
import csvHelper from '@/utils/csv-helper'
import forEach from 'lodash/forEach'
import Loader from '@/components/dashboard/Loader'
import { participantService } from '@/server-util/participant-service'
export default {
  created: function () {
    this.checkUserErrorStatus()
  },
  data: function () {
    return {
      currentSelectedTab: 1,
      showAlertDialog: false,
      errorMsg: false,
      showSpinner: false,
      showExportButton: true,
      selectedMilestoneInfoObj: null,
      selectedMilestoneTitleObj: null,
      columnAlias: [],
      columnRespKey: [],
      columnNameToShow: [],
      linkColumnNames: [],
      responseToPass: [],
      responseToPassForExport: [],
      sortColumnNames: [],
      showCertificateList: false,
      reportArr: [],
      csvFileName: '',
      isViewBtnClicked: false,
      isExportBtnClicked: false,
      selectedGroupObj: -1
    }
  },
  components: {
    'certificate-grid-tab': CertificateGridTab,
    'report-filter-bar': ReportFilterBar,
    'sortable-list': list,
    'Copyright-Element': CopyrightElement,
    'report-group-filter-bar': ReportGroupFilterBar,
    'alert-box': AlertBox,
    'error-page': ErrorPage,
    'loader': Loader
  },
  methods: {
    setGroupObj (value) {
      // AK: When user selected particular Group object then update it in parent file too
      this.selectedGroupObj = value
    },
    checkUserErrorStatus: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '') {
        participantService
          .getUserErrorStatus(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              const jsonObj = responseObj.data
              this.checkAndShowAlert(jsonObj)
            }
          }, errorObj => {
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('getUserErrorStatus Error :::' + this.errorMsg)
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING GET ERROR INFO'
        )
      }
    },
    checkAndShowAlert: function (jsonObj) {
      if (jsonObj !== undefined && jsonObj !== 'undefined' && jsonObj !== null && jsonObj !== 'null' && jsonObj !== '') {
        const isLoggedOut = jsonObj.IsAdminLoggedOut
        const profileError = jsonObj.ProfileError
        if (isLoggedOut) {
          this.showAlertDialog = true
          this.errorMsg = constants.Logged_Out_From_Another_Platform_Error_Msg
        } else if (profileError === constants.Change_Password_Error_Profile) {
          this.showAlertDialog = true
          this.errorMsg = constants.Change_Password_Alert_Msg
        }
      }
    },
    peformCleanUpOperationOnSignOut: function () {
      var store = this.$store
      var cookies = this.$cookies
      cookies.remove(constants.LOGIN_COOKIE_KEY)
      cookies.remove(constants.LOGIN_USER_COOKIE)
      store.state.isUserProfileLoaded = false
      localStorage.removeItem(constants.LOGIN_USER_COOKIE)
      localStorage.setItem('selectedMenu', 0)
      localStorage.setItem('selectedSubMenu', 0)
      localStorage.clear()
      this.$store.state.curr_user = null
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      switch (this.errorMsg) {
        case constants.Logged_Out_From_Another_Platform_Error_Msg:
          this.peformCleanUpOperationOnSignOut()
          break
        case constants.Change_Password_Alert_Msg:
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.EditProfile)
          this.$router.push('/profile?OpenPopUp=true')
          break
      }
    },
    setGroupCourseObj (value) {
      // AK: When user selected particular group object then update it in parent file too
      this.selectedGroupCourseObj = value
    },
    setCohortObj (value) {
      // AK: When user selected particular cohort object then update it in parent file too
      this.selectedCohortObj = value
    },
    selectedTab (value) {
      // AK: As soon as user changed Tab then hide report list
      var tabChanged = false
      if (parseInt(this.currentSelectedTab) !== value) {
        this.showCertificateList = false
        tabChanged = true
      }
      // AK: Update Currently selected Tab
      this.currentSelectedTab = value
      if (tabChanged) {
        this.updateViewBtnClickedFlag(true)
      }
    },
    updateViewBtnClickedFlag (value) {
      this.isViewBtnClicked = value
      if (value) {
        switch (parseInt(this.currentSelectedTab)) {
          case 1:
            this.selectedGroupObj = -1
            this.getAggricateCerficiateAtGCCLevel()
            break
          case 2:
            this.selectedGroupObj = -1
            this.getUserMatricesReportAtGCCLevel()
            break
          case 3:
            this.getAggricateCerficiateAtGroupLevel()
            break
          case 4:
            this.getUserMatricesReportAtGroupLevel()
            break
        }
      }
    },
    exportCSV (value) {
      this.isExportBtnClicked = value
      if (value) {
        switch (parseInt(this.currentSelectedTab)) {
          case 1:
            this.getAggricateCerficiateAtGCCLevel()
            break
          case 2:
            this.getUserMatricesReportAtGCCLevel()
            break
          case 3:
            this.getAggricateCerficiateAtGroupLevel()
            break
          case 4:
            this.getUserMatricesReportAtGroupLevel()
            break
        }
      }
    },
    getAggricateCerficiateAtGroupLevel: function () {
      var storeObj = this.$store
      var _this = this
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '' && this.selectedGroupObj !== undefined && this.selectedGroupObj !== 'undefined' && this.selectedGroupObj !== null && this.selectedGroupObj !== 'null' && this.selectedGroupObj !== '' && this.selectedGroupObj !== -1) {
        _this.$store.state.isLoading = true
        reportService
          .getAggricateCerficiateReportForGroup(
            storeObj.state.access_token,
            this.selectedGroupObj.GroupId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.reportArr = responseObj.data
              console.log('::: ' + JSON.stringify(this.reportArr))
              _this.$store.state.isLoading = false
              if (_this.reportArr.length === 0) {
                _this.showCertificateList = false
                _this.showAlertDialog = true
                _this.errorMsg = 'No reports found.'
              } else {
                _this.addColumnAlias()
              }
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING AGGRIGATE PROGRESS REPORT'
        )
      }
    },
    getUserMatricesReportAtGroupLevel: function () {
      var storeObj = this.$store
      var _this = this
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '' && this.selectedGroupObj !== undefined && this.selectedGroupObj !== 'undefined' && this.selectedGroupObj !== null && this.selectedGroupObj !== 'null' && this.selectedGroupObj !== '' && this.selectedGroupObj !== -1) {
        _this.$store.state.isLoading = true
        reportService
          .getUserMatricesCerficiateReportForGroup(
            storeObj.state.access_token,
            this.selectedGroupObj.GroupId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.reportArr = responseObj.data
              console.log('::: ' + JSON.stringify(this.reportArr))
              _this.$store.state.isLoading = false
              if (_this.reportArr.length === 0) {
                _this.showCertificateList = false
                _this.showAlertDialog = true
                _this.errorMsg = 'No reports found.'
              } else {
                _this.addColumnAlias()
              }
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOAD USER MATRICES REPORT'
        )
      }
    },
    getAggricateCerficiateAtGCCLevel: function () {
      var storeObj = this.$store
      var _this = this
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '' && this.selectedGroupCourseObj !== undefined && this.selectedGroupCourseObj !== 'undefined' && this.selectedGroupCourseObj !== null && this.selectedGroupCourseObj !== 'null' && this.selectedGroupCourseObj !== '' && this.selectedCohortObj !== undefined && this.selectedCohortObj !== 'undefined' && this.selectedCohortObj !== null && this.selectedCohortObj !== 'null' && this.selectedCohortObj !== '') {
        _this.$store.state.isLoading = true
        reportService
          .getAggricateCerficiateReport(
            storeObj.state.access_token,
            this.selectedGroupCourseObj.GroupId,
            this.selectedGroupCourseObj.GroupCourseMasterId,
            this.selectedCohortObj.CohortId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.reportArr = responseObj.data
              console.log('::: ' + JSON.stringify(this.reportArr))
              _this.$store.state.isLoading = false
              if (_this.reportArr.length === 0) {
                _this.showCertificateList = false
                _this.showAlertDialog = true
                _this.errorMsg = 'No reports found.'
              } else {
                _this.addColumnAlias()
              }
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING AGGRIGATE PROGRESS REPORT'
        )
      }
    },
    getUserMatricesReportAtGCCLevel: function () {
      var storeObj = this.$store
      var _this = this
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '' && this.selectedGroupCourseObj !== undefined && this.selectedGroupCourseObj !== 'undefined' && this.selectedGroupCourseObj !== null && this.selectedGroupCourseObj !== 'null' && this.selectedGroupCourseObj !== '' && this.selectedCohortObj !== undefined && this.selectedCohortObj !== 'undefined' && this.selectedCohortObj !== null && this.selectedCohortObj !== 'null' && this.selectedCohortObj !== '') {
        _this.$store.state.isLoading = true
        reportService
          .getUserMatricesCerficiateReport(
            storeObj.state.access_token,
            this.selectedGroupCourseObj.GroupId,
            this.selectedGroupCourseObj.GroupCourseMasterId,
            this.selectedCohortObj.CohortId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.reportArr = responseObj.data
              console.log('::: ' + JSON.stringify(this.reportArr))
              _this.$store.state.isLoading = false
              if (_this.reportArr.length === 0) {
                _this.showCertificateList = false
                _this.showAlertDialog = true
                _this.errorMsg = 'No reports found.'
              } else {
                _this.addColumnAlias()
              }
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOAD USER MATRICES REPORT'
        )
      }
    },
    addColumnAlias: function () {
      this.columnAlias = []
      switch (parseInt(this.currentSelectedTab)) {
        case 1:
        case 3:
          this.columnAlias = ['# of Participants', '# of certificate generated', 'PDF Downloads', 'Image Downloads', '# of Downloads', 'Total Views', 'Total Share', 'Sent by email', '# of allowed certificates', '# of disallowed certificates', 'Avg Views Per Participant', 'Avg Downloads Per Participant', 'Avg Shares Per Participant']
          break
        case 2:
          this.columnAlias = ['Participant Name', 'User Progress', 'Certificate PDF Url', 'Certificate Image Url', 'Allow Ceritificate', 'Total Views', 'Total Share', 'Download PDF Count', 'Download Image Count']
          break
        case 4:
          this.columnAlias = ['Participant Name', 'Email', 'Username', 'Certificate PDF Url', 'Certificate Image Url', 'Allow Ceritificate', 'Total Views', 'Total Share', 'Download PDF Count', 'Download Image Count']
          break
      }
      this.addColumnRespKey()
    },
    addColumnRespKey: function () {
      this.columnRespKey = []
      switch (parseInt(this.currentSelectedTab)) {
        case 1:
          this.sortColumnNames = []
          this.csvFileName = 'AggregateCertificateReport(' + this.selectedGroupCourseObj.GroupName + '-' + this.selectedGroupCourseObj.CourseTitle + ')'
          this.columnRespKey = ['TotalParticipantsInTheCohort', 'TotalCertificatesGenerated', 'TotalPDFDownloads', 'TotalImageDownloads', 'TotalDownloads', 'TotalViews', 'TotalShares', 'CertificatesSentByEmail', 'TotalAllowedCertificates', 'TotalDisallowedCertificates', 'AvgViewsPerParticipant', 'AvgDownloadsPerParticipant', 'AvgSharesPerParticipant']
          break
        case 2:
          this.sortColumnNames = ['FullName', 'UserProgress']
          this.csvFileName = 'UserMatricesCertificateReport(' + this.selectedGroupCourseObj.GroupName + '-' + this.selectedGroupCourseObj.CourseTitle + ')'
          this.columnRespKey = ['FullName', 'UserProgress', 'CertificatePDFUrl', 'CertificateImgUrl', 'AllowView', 'TotalViews', 'SharesCount', 'DownloadPDFCount', 'DownloadImageCount']
          break
        case 3:
          this.sortColumnNames = []
          this.csvFileName = 'AggregateCertificateReport(' + this.selectedGroupObj.GroupName + ')'
          this.columnRespKey = ['TotalParticipantsInTheCohort', 'TotalCertificatesGenerated', 'TotalPDFDownloads', 'TotalImageDownloads', 'TotalDownloads', 'TotalViews', 'TotalShares', 'CertificatesSentByEmail', 'TotalAllowedCertificates', 'TotalDisallowedCertificates', 'AvgViewsPerParticipant', 'AvgDownloadsPerParticipant', 'AvgSharesPerParticipant']
          break
        case 4:
          this.sortColumnNames = ['FullName']
          this.csvFileName = 'UserMatricesCertificateReport(' + this.selectedGroupObj.GroupName + ')'
          this.columnRespKey = ['FullName', 'Email', 'UserName', 'CertificatePDFUrl', 'CertificateImgUrl', 'AllowView', 'TotalViews', 'SharesCount', 'DownloadPDFCount', 'DownloadImageCount']
          break
      }
      this.bindResponseObj()
    },
    bindResponseObj: function () {
      this.responseToPass = []
      this.responseToPassForExport = []
      if (this.currentSelectedTab === 1 || this.currentSelectedTab === 3) {
        this.responseToPassForExport.push(this.reportArr)
        this.responseToPass.push(this.reportArr)
      } else {
        forEach(this.reportArr, (obj) => {
          var userObjObjToPush = {
            FullName: obj.FullName,
            UserProgress: obj.UserProgress,
            CertificatePDFUrl: obj.CertificatePDFUrl !== undefined && obj.CertificatePDFUrl !== 'undefined' && obj.CertificatePDFUrl !== null && obj.CertificatePDFUrl !== 'null' && obj.CertificatePDFUrl !== '' ? '<a href=\'' + obj.CertificatePDFUrl + '\' target=\'_BLANK\'>PDF Link</a>' : 'NA',
            CertificateImgUrl: obj.CertificateImgUrl !== undefined && obj.CertificateImgUrl !== 'undefined' && obj.CertificateImgUrl !== null && obj.CertificateImgUrl !== 'null' && obj.CertificateImgUrl !== '' ? '<a href=\'' + obj.CertificateImgUrl + '\' target=\'_BLANK\'>Image Link</a>' : 'NA',
            AllowView: obj.AllowView ? 'Yes' : 'No',
            TotalViews: obj.TotalViews,
            SharesCount: obj.SharesCount,
            DownloadPDFCount: obj.DownloadPDFCount,
            DownloadImageCount: obj.DownloadImageCount,
            Email: obj.Email,
            UserName: obj.UserName
          }
          this.responseToPass.push(userObjObjToPush)
          userObjObjToPush = {
            FullName: obj.FullName,
            UserProgress: obj.UserProgress,
            CertificatePDFUrl: obj.CertificatePDFUrl !== undefined && obj.CertificatePDFUrl !== 'undefined' && obj.CertificatePDFUrl !== null && obj.CertificatePDFUrl !== 'null' && obj.CertificatePDFUrl !== '' ? obj.CertificatePDFUrl : 'NA',
            CertificateImgUrl: obj.CertificateImgUrl !== undefined && obj.CertificateImgUrl !== 'undefined' && obj.CertificateImgUrl !== null && obj.CertificateImgUrl !== 'null' && obj.CertificateImgUrl !== '' ? obj.CertificateImgUrl : 'NA',
            AllowView: obj.AllowView ? 'Yes' : 'No',
            TotalViews: obj.TotalViews,
            SharesCount: obj.SharesCount,
            DownloadPDFCount: obj.DownloadPDFCount,
            DownloadImageCount: obj.DownloadImageCount,
            Email: obj.Email,
            UserName: obj.UserName
          }
          this.responseToPassForExport.push(userObjObjToPush)
        })
      }
      this.bindColumnsNameAndAlias()
    },
    bindColumnsNameAndAlias: function () {
      this.columnNameToShow = []
      for (var i = 0; i < this.columnRespKey.length; i++) {
        var obj = {
          ColumnName: this.columnRespKey[i],
          ColumnAlias: this.columnAlias[i]
        }
        this.columnNameToShow.push(obj)
      }
      // console.log('Column And alias Name Obj >>>> ' + JSON.stringify(this.columnNameToShow))
      this.processAndExecuteSelectedOperation()
    },
    processAndExecuteSelectedOperation: function () {
      if ((!this.isExportBtnClicked) && this.isViewBtnClicked) {
        // AK: If export btn not clicked and list is shown previously then show list only
        this.showCertificateList = true
      } else if (this.isExportBtnClicked && (!this.isViewBtnClicked)) {
        // AK: If user directly clicked on export button without clicking view first then export data
        this.exportData()
      } else if (this.isExportBtnClicked && this.isViewBtnClicked) {
        // AK: If user performed both operations then performed both operations
        this.showCertificateList = true
        this.exportData()
      }
    },
    exportData: function () {
      return csvHelper.export(this.getExportReportArr, this.columnRespKey, this.columnAlias, this.csvFileName)
    }
  },
  computed: {
    isUserGroupAdmin: {
      get: function () {
        var userObj = this.$store.state.curr_user
        if (parseInt(userObj.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        } else {
          return false
        }
      }
    },
    getReportArr: {
      get: function () {
        return this.responseToPass
      }
    },
    getExportReportArr: {
      get: function () {
        return this.responseToPassForExport
      }
    },
    getCurrentlySelectedTab: {
      get: function () {
        return this.currentSelectedTab
      }
    }
  },
  name: 'CertificateReport'
}
</script>

<style scoped>
.CertificateReport {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.border-red{
  border: 1px solid red;
}
.border-yellow{
  border: 2px solid yellow;
}
/* Using Only for footer */
.footer{
    /* position: fixed; */
    left: 38px !important;
    bottom: 0 !important;
    width: 100% !important;
    /* background-color: red; */
    /* color: white; */
    text-align: center !important;
    margin-bottom: 1% !important;
    font-size: 12px !important;
}
.margin-left-1point5Perc{
  margin-left:1.5% !important;
}
.margin-right-1point5Perc{
  margin-right:1.5% !important;
}
.width-97Point4{
  width:97.4% !important;
}
.milestoneList{
  min-height: 57vh;
}
</style>


// WEBPACK FOOTER //
// src/pages/CertificateReport.vue